// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeItem-module__font-s-10___orpJc {
  font-size: 10px !important;
}

.TimeItem-module__font-s-12___MdUy3 {
  font-size: 12px !important;
}

.TimeItem-module__font-s-13___SLYaA {
  font-size: 13px !important;
}

.TimeItem-module__font-s-14___xHbk2 {
  font-size: 14px !important;
}

.TimeItem-module__font-s-15___Zxdly {
  font-size: 15px !important;
}

.TimeItem-module__font-s-16___zmVnj {
  font-size: 16px !important;
}

.TimeItem-module__font-s-18___bS1Hf {
  font-size: 18px !important;
}

.TimeItem-module__font-s-20___VKaaL {
  font-size: 20px !important;
}

.TimeItem-module__font-s-22___bjpi3 {
  font-size: 22px !important;
}

.TimeItem-module__font-s-28___L5Ora {
  font-size: 28px !important;
}

.TimeItem-module__font-w-400___LDR5F {
  font-weight: 400 !important;
}

.TimeItem-module__font-w-500___xTca_ {
  font-weight: 500 !important;
}

.TimeItem-module__font-w-600___znZWU {
  font-weight: 600 !important;
}

.TimeItem-module__font-w-700___hfzE8 {
  font-weight: 700 !important;
}

.TimeItem-module__p-5___BPH30 {
  padding: 5px !important;
}

.TimeItem-module__p-12___AkGR8 {
  padding: 12px !important;
}

.TimeItem-module__p-16___O4WK3 {
  padding: 16px !important;
}

.TimeItem-module__p-30___Zf1dy {
  padding: 30px !important;
}

.TimeItem-module__p-b-0___uF6D9 {
  padding-bottom: 0 !important;
}

.TimeItem-module__p-b-5___rx5cB {
  padding-bottom: 5px !important;
}

.TimeItem-module__p-b-10___NkoI_ {
  padding-bottom: 10px !important;
}

.TimeItem-module__p-b-12___zOhPh {
  padding-bottom: 12px !important;
}

.TimeItem-module__p-b-16___smTRj {
  padding-bottom: 16px !important;
}

.TimeItem-module__p-b-18___A6tIw {
  padding-bottom: 18px !important;
}

.TimeItem-module__p-b-20___m06lV {
  padding-bottom: 20px !important;
}

.TimeItem-module__p-b-25___v6UKF {
  padding-bottom: 25px !important;
}

.TimeItem-module__p-b-30___Xdpxz {
  padding-bottom: 30px !important;
}

.TimeItem-module__p-b-50___x9mDW {
  padding-bottom: 50px !important;
}

.TimeItem-module__p-t-0___hdDIF {
  padding-top: 0 !important;
}

.TimeItem-module__p-t-12___gL94s {
  padding-top: 12px !important;
}

.TimeItem-module__p-t-16___thFQH {
  padding-top: 16px !important;
}

.TimeItem-module__p-t-18___o3NNb {
  padding-top: 18px !important;
}

.TimeItem-module__p-t-20___jnUjU {
  padding-top: 20px !important;
}

.TimeItem-module__p-t-30___hZ5Ag {
  padding-top: 30px !important;
}

.TimeItem-module__p-t-40___OW61f {
  padding-top: 40px !important;
}

.TimeItem-module__p-t-50___fACsE {
  padding-top: 50px !important;
}

.TimeItem-module__p-l-20___fCdx9 {
  padding-left: 20px !important;
}

.TimeItem-module__p-l-30___LwjB9 {
  padding-left: 30px !important;
}

.TimeItem-module__p-l-40___cp74c {
  padding-left: 40px !important;
}

.TimeItem-module__p-r-16___A3Bq9 {
  padding-right: 16px !important;
}

.TimeItem-module__p-r-20___fEc0A {
  padding-right: 20px !important;
}

.TimeItem-module__p-r-30___JwIpg {
  padding-right: 30px !important;
}

.TimeItem-module__p-r-50___LPi8M {
  padding-right: 50px !important;
}

.TimeItem-module__p-r-60___bq0oq {
  padding-right: 60px !important;
}

.TimeItem-module__m-b-1___lGArj {
  margin-bottom: 1px !important;
}

.TimeItem-module__m-b-2___lEJH3 {
  margin-bottom: 2px !important;
}

.TimeItem-module__m-b-6___JOvEN {
  margin-bottom: 6px !important;
}

.TimeItem-module__m-b-8___TBDA9 {
  margin-bottom: 8px !important;
}

.TimeItem-module__m-b-10___fiyu2 {
  margin-bottom: 10px !important;
}

.TimeItem-module__m-b-14___kBpDI {
  margin-bottom: 14px !important;
}

.TimeItem-module__m-b-16___QHLrZ {
  margin-bottom: 16px !important;
}

.TimeItem-module__m-b-20___TsTuA {
  margin-bottom: 20px !important;
}

.TimeItem-module__m-b-22___B5ygA {
  margin-bottom: 22px !important;
}

.TimeItem-module__m-b-24___rrwHr {
  margin-bottom: 24px !important;
}

.TimeItem-module__m-b-30___klKJm {
  margin-bottom: 30px !important;
}

.TimeItem-module__m-b-32___oQWgt {
  margin-bottom: 32px !important;
}

.TimeItem-module__m-b-40___NLOzM {
  margin-bottom: 40px !important;
}

.TimeItem-module__m-t-2___OZyDQ {
  margin-top: 2px !important;
}

.TimeItem-module__m-t-3___EOBGA {
  margin-top: 3px !important;
}

.TimeItem-module__m-t-4___cP9YQ {
  margin-top: 4px !important;
}

.TimeItem-module__m-t-5___F0pn4 {
  margin-top: 5px !important;
}

.TimeItem-module__m-t-8___XteoU {
  margin-top: 8px !important;
}

.TimeItem-module__m-t-10___E8CAx {
  margin-top: 10px !important;
}

.TimeItem-module__m-t-15___cD7bU {
  margin-top: 15px !important;
}

.TimeItem-module__m-t-16___VCjt1 {
  margin-top: 16px !important;
}

.TimeItem-module__m-t-20___CQISE {
  margin-top: 20px !important;
}

.TimeItem-module__m-t-22___qfWOe {
  margin-top: 22px !important;
}

.TimeItem-module__m-t-30___ehfxE {
  margin-top: 30px !important;
}

.TimeItem-module__m-t-32___ZNOJx {
  margin-top: 32px !important;
}

.TimeItem-module__m-l-auto___GrFfI {
  margin-left: auto !important;
}

.TimeItem-module__m-l-4___BQxD7 {
  margin-left: 4px !important;
}

.TimeItem-module__m-l-5___ghYJz {
  margin-left: 5px !important;
}

.TimeItem-module__m-l-6___W4t70 {
  margin-left: 6px !important;
}

.TimeItem-module__m-l-8___SzyFg {
  margin-left: 8px !important;
}

.TimeItem-module__m-l-10___QA508 {
  margin-left: 10px !important;
}

.TimeItem-module__m-l-16___lCoPK {
  margin-left: 16px !important;
}

.TimeItem-module__m-l-20___NyUY5 {
  margin-left: 20px !important;
}

.TimeItem-module__m-l-24___utjQw {
  margin-left: 24px !important;
}

.TimeItem-module__m-l-30___ppzUX {
  margin-left: 30px !important;
}

.TimeItem-module__m-l-35___HGZ7D {
  margin-left: 35px !important;
}

.TimeItem-module__m-l-40___jxbrY {
  margin-left: 40px !important;
}

.TimeItem-module__m-r-8___Xx5L3 {
  margin-right: 8px !important;
}

.TimeItem-module__m-r-10___PXBGg {
  margin-right: 10px !important;
}

.TimeItem-module__m-r-16___VBO_I {
  margin-right: 16px !important;
}

.TimeItem-module__m-r-20___FRNG_ {
  margin-right: 20px !important;
}

.TimeItem-module__m-r-24___ZVWEZ {
  margin-right: 24px !important;
}

.TimeItem-module__m-r-30___Lc9tB {
  margin-right: 30px !important;
}

.TimeItem-module__m-r-40___ktC0V {
  margin-right: 40px !important;
}

.TimeItem-module__border-r-3___G0hRe {
  border-radius: 3px !important;
}

.TimeItem-module__border-r-4___lwe0t {
  border-radius: 4px !important;
}

.TimeItem-module__border-r-6___wIXvu {
  border-radius: 6px !important;
}

.TimeItem-module__border-r-10___kvbZX {
  border-radius: 10px !important;
}

.TimeItem-module__border-r-12___cZHgu {
  border-radius: 12px !important;
}

.TimeItem-module__border-r-16___g6Q8h {
  border-radius: 16px !important;
}

.TimeItem-module__border-r-50___d3RSO {
  border-radius: 50% !important;
}

.TimeItem-module__primary-border___XTTpY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-b___QCwY7 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-t___OXY7F {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-l___rcD8n {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__primary-border-r___jnj3H {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TimeItem-module__secondary-border___u1Nws {
  border: 1px solid #637768;
}

.TimeItem-module__secondary-border-b___zdLok {
  border-bottom: 1px solid #637768;
}

.TimeItem-module__secondary-border-t___xKlP2 {
  border-top: 1px solid #637768;
}

.TimeItem-module__secondary-border-l___mZ82S {
  border-left: 1px solid #637768;
}

.TimeItem-module__secondary-border-r___dN258 {
  border-right: 1px solid #637768;
}

.TimeItem-module__gap-0____AL3d {
  gap: 0 !important;
}

.TimeItem-module__gap-2___wlMde {
  gap: 2px !important;
}

.TimeItem-module__gap-4___zbicR {
  gap: 4px !important;
}

.TimeItem-module__gap-5___j0I6C {
  gap: 5px !important;
}

.TimeItem-module__gap-6___XZYK2 {
  gap: 6px !important;
}

.TimeItem-module__gap-8___QUncS {
  gap: 8px !important;
}

.TimeItem-module__gap-10___DV3xL {
  gap: 10px !important;
}

.TimeItem-module__gap-12___zr4ay {
  gap: 12px !important;
}

.TimeItem-module__gap-14___LcxVK {
  gap: 14px !important;
}

.TimeItem-module__gap-16___JgNSk {
  gap: 16px !important;
}

.TimeItem-module__gap-18___mguBq {
  gap: 18px !important;
}

.TimeItem-module__gap-20___eBQyI {
  gap: 20px !important;
}

.TimeItem-module__gap-24___zkfQA {
  gap: 24px !important;
}

.TimeItem-module__gap-26___B_HCj {
  gap: 26px !important;
}

.TimeItem-module__gap-30___i75u1 {
  gap: 30px !important;
}

.TimeItem-module__gap-32___aHnZz {
  gap: 32px !important;
}

.TimeItem-module__gap-40___RMuls {
  gap: 40px !important;
}

.TimeItem-module__gap-50___XBJCq {
  gap: 50px !important;
}

.TimeItem-module__flex-1___io0Wl {
  flex: 1;
}

.TimeItem-module__flex-none___TeiCB {
  flex: none !important;
}

.TimeItem-module__flex-column___YXfaf {
  display: flex;
  flex-direction: column !important;
}

.TimeItem-module__flex-row___ZP7cQ {
  display: flex;
  flex-direction: row !important;
}

.TimeItem-module__vertically-centered___G7LUR {
  display: flex;
  align-items: center !important;
}

.TimeItem-module__horizontally-centered___d1ll8 {
  display: flex;
  justify-content: center !important;
}

.TimeItem-module__horizontally-end___BopAo {
  display: flex;
  justify-content: end !important;
}

.TimeItem-module__vertically-start___AwVCn {
  display: flex;
  align-items: start !important;
}

.TimeItem-module__space-between___odc2M {
  display: flex;
  justify-content: space-between !important;
}

.TimeItem-module__flex-wrap___bRTI6 {
  flex-wrap: wrap !important;
}

.TimeItem-module__height-100___L86hp {
  height: 100%;
}

.TimeItem-module__width-50___rcF91 {
  width: 50% !important;
}

.TimeItem-module__width-100___vIx4N {
  width: 100%;
}

.TimeItem-module__cursor-pointer___DN6C_ {
  cursor: pointer;
}

.TimeItem-module__cursor-not-allowed___DxXqS {
  cursor: not-allowed !important;
}

.TimeItem-module__absolute-centered___WurpV {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TimeItem-module__absolute___VVogs {
  position: absolute;
}

.TimeItem-module__relative___hfa43 {
  position: relative;
}

.TimeItem-module__fixed___rh4OW {
  position: fixed;
}

.TimeItem-module__visible___PyNhz {
  opacity: 1;
}

.TimeItem-module__invisible___qa91g {
  opacity: 0;
}

.TimeItem-module__col-90___H6kvW {
  width: 90% !important;
}

.TimeItem-module__col-auto___iPc_D {
  width: auto !important;
}

.TimeItem-module__medical-tabs___z90l3 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TimeItem-module__medical-table-new___QFxAK {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimeItem-module__medical-table-new___QFxAK:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimeItem-module__medical-table-new___QFxAK::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimeItem-module__medical-table-new___QFxAK::-webkit-scrollbar-track {
  display: none;
}
.TimeItem-module__medical-table-new___QFxAK.TimeItem-module__no-pagination___j_wAe {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimeItem-module__medical-table-new___QFxAK.TimeItem-module__no-pagination___j_wAe:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimeItem-module__medical-table-new___QFxAK.TimeItem-module__no-pagination___j_wAe::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimeItem-module__medical-table-new___QFxAK.TimeItem-module__no-pagination___j_wAe::-webkit-scrollbar-track {
  display: none;
}

.TimeItem-module__medical-table-empty___ryeOC {
  padding: 14px 40px !important;
}

.TimeItem-module__icon-btn___HZR0y {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TimeItem-module__search-icon___dU6GW {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TimeItem-module__disable-select___fksen {
  user-select: none;
}

.TimeItem-module__break-word___u3wKm {
  word-break: break-word;
}

.TimeItem-module__popup-clear-btn___wau8H {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TimeItem-module__scroll-m-b-20___t6ReQ {
  scroll-margin-bottom: 20px;
}

.TimeItem-module__date___yx8r0 {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #375844;
}

.TimeItem-module__time___JyWLk {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/TimeItem/TimeItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBAFmD;EFrBnD,iBAAA;EACA,cAAA;AA+pBF;;AA5pBA;EEkBE,+BApBO;EAqBP,gBAFmD;EFfnD,iBAAA;EACA,cAAA;AAgqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.date {\n  @include get-font($roboto);\n  line-height: 150%;\n  color: get-color(greenNew, dark);\n}\n\n.time {\n  @include get-font($roboto);\n  line-height: 15px;\n  color: get-color(greenNew, medium);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TimeItem-module__font-s-10___orpJc`,
	"fontS12": `TimeItem-module__font-s-12___MdUy3`,
	"fontS13": `TimeItem-module__font-s-13___SLYaA`,
	"fontS14": `TimeItem-module__font-s-14___xHbk2`,
	"fontS15": `TimeItem-module__font-s-15___Zxdly`,
	"fontS16": `TimeItem-module__font-s-16___zmVnj`,
	"fontS18": `TimeItem-module__font-s-18___bS1Hf`,
	"fontS20": `TimeItem-module__font-s-20___VKaaL`,
	"fontS22": `TimeItem-module__font-s-22___bjpi3`,
	"fontS28": `TimeItem-module__font-s-28___L5Ora`,
	"fontW400": `TimeItem-module__font-w-400___LDR5F`,
	"fontW500": `TimeItem-module__font-w-500___xTca_`,
	"fontW600": `TimeItem-module__font-w-600___znZWU`,
	"fontW700": `TimeItem-module__font-w-700___hfzE8`,
	"p5": `TimeItem-module__p-5___BPH30`,
	"p12": `TimeItem-module__p-12___AkGR8`,
	"p16": `TimeItem-module__p-16___O4WK3`,
	"p30": `TimeItem-module__p-30___Zf1dy`,
	"pB0": `TimeItem-module__p-b-0___uF6D9`,
	"pB5": `TimeItem-module__p-b-5___rx5cB`,
	"pB10": `TimeItem-module__p-b-10___NkoI_`,
	"pB12": `TimeItem-module__p-b-12___zOhPh`,
	"pB16": `TimeItem-module__p-b-16___smTRj`,
	"pB18": `TimeItem-module__p-b-18___A6tIw`,
	"pB20": `TimeItem-module__p-b-20___m06lV`,
	"pB25": `TimeItem-module__p-b-25___v6UKF`,
	"pB30": `TimeItem-module__p-b-30___Xdpxz`,
	"pB50": `TimeItem-module__p-b-50___x9mDW`,
	"pT0": `TimeItem-module__p-t-0___hdDIF`,
	"pT12": `TimeItem-module__p-t-12___gL94s`,
	"pT16": `TimeItem-module__p-t-16___thFQH`,
	"pT18": `TimeItem-module__p-t-18___o3NNb`,
	"pT20": `TimeItem-module__p-t-20___jnUjU`,
	"pT30": `TimeItem-module__p-t-30___hZ5Ag`,
	"pT40": `TimeItem-module__p-t-40___OW61f`,
	"pT50": `TimeItem-module__p-t-50___fACsE`,
	"pL20": `TimeItem-module__p-l-20___fCdx9`,
	"pL30": `TimeItem-module__p-l-30___LwjB9`,
	"pL40": `TimeItem-module__p-l-40___cp74c`,
	"pR16": `TimeItem-module__p-r-16___A3Bq9`,
	"pR20": `TimeItem-module__p-r-20___fEc0A`,
	"pR30": `TimeItem-module__p-r-30___JwIpg`,
	"pR50": `TimeItem-module__p-r-50___LPi8M`,
	"pR60": `TimeItem-module__p-r-60___bq0oq`,
	"mB1": `TimeItem-module__m-b-1___lGArj`,
	"mB2": `TimeItem-module__m-b-2___lEJH3`,
	"mB6": `TimeItem-module__m-b-6___JOvEN`,
	"mB8": `TimeItem-module__m-b-8___TBDA9`,
	"mB10": `TimeItem-module__m-b-10___fiyu2`,
	"mB14": `TimeItem-module__m-b-14___kBpDI`,
	"mB16": `TimeItem-module__m-b-16___QHLrZ`,
	"mB20": `TimeItem-module__m-b-20___TsTuA`,
	"mB22": `TimeItem-module__m-b-22___B5ygA`,
	"mB24": `TimeItem-module__m-b-24___rrwHr`,
	"mB30": `TimeItem-module__m-b-30___klKJm`,
	"mB32": `TimeItem-module__m-b-32___oQWgt`,
	"mB40": `TimeItem-module__m-b-40___NLOzM`,
	"mT2": `TimeItem-module__m-t-2___OZyDQ`,
	"mT3": `TimeItem-module__m-t-3___EOBGA`,
	"mT4": `TimeItem-module__m-t-4___cP9YQ`,
	"mT5": `TimeItem-module__m-t-5___F0pn4`,
	"mT8": `TimeItem-module__m-t-8___XteoU`,
	"mT10": `TimeItem-module__m-t-10___E8CAx`,
	"mT15": `TimeItem-module__m-t-15___cD7bU`,
	"mT16": `TimeItem-module__m-t-16___VCjt1`,
	"mT20": `TimeItem-module__m-t-20___CQISE`,
	"mT22": `TimeItem-module__m-t-22___qfWOe`,
	"mT30": `TimeItem-module__m-t-30___ehfxE`,
	"mT32": `TimeItem-module__m-t-32___ZNOJx`,
	"mLAuto": `TimeItem-module__m-l-auto___GrFfI`,
	"mL4": `TimeItem-module__m-l-4___BQxD7`,
	"mL5": `TimeItem-module__m-l-5___ghYJz`,
	"mL6": `TimeItem-module__m-l-6___W4t70`,
	"mL8": `TimeItem-module__m-l-8___SzyFg`,
	"mL10": `TimeItem-module__m-l-10___QA508`,
	"mL16": `TimeItem-module__m-l-16___lCoPK`,
	"mL20": `TimeItem-module__m-l-20___NyUY5`,
	"mL24": `TimeItem-module__m-l-24___utjQw`,
	"mL30": `TimeItem-module__m-l-30___ppzUX`,
	"mL35": `TimeItem-module__m-l-35___HGZ7D`,
	"mL40": `TimeItem-module__m-l-40___jxbrY`,
	"mR8": `TimeItem-module__m-r-8___Xx5L3`,
	"mR10": `TimeItem-module__m-r-10___PXBGg`,
	"mR16": `TimeItem-module__m-r-16___VBO_I`,
	"mR20": `TimeItem-module__m-r-20___FRNG_`,
	"mR24": `TimeItem-module__m-r-24___ZVWEZ`,
	"mR30": `TimeItem-module__m-r-30___Lc9tB`,
	"mR40": `TimeItem-module__m-r-40___ktC0V`,
	"borderR3": `TimeItem-module__border-r-3___G0hRe`,
	"borderR4": `TimeItem-module__border-r-4___lwe0t`,
	"borderR6": `TimeItem-module__border-r-6___wIXvu`,
	"borderR10": `TimeItem-module__border-r-10___kvbZX`,
	"borderR12": `TimeItem-module__border-r-12___cZHgu`,
	"borderR16": `TimeItem-module__border-r-16___g6Q8h`,
	"borderR50": `TimeItem-module__border-r-50___d3RSO`,
	"primaryBorder": `TimeItem-module__primary-border___XTTpY`,
	"primaryBorderB": `TimeItem-module__primary-border-b___QCwY7`,
	"primaryBorderT": `TimeItem-module__primary-border-t___OXY7F`,
	"primaryBorderL": `TimeItem-module__primary-border-l___rcD8n`,
	"primaryBorderR": `TimeItem-module__primary-border-r___jnj3H`,
	"secondaryBorder": `TimeItem-module__secondary-border___u1Nws`,
	"secondaryBorderB": `TimeItem-module__secondary-border-b___zdLok`,
	"secondaryBorderT": `TimeItem-module__secondary-border-t___xKlP2`,
	"secondaryBorderL": `TimeItem-module__secondary-border-l___mZ82S`,
	"secondaryBorderR": `TimeItem-module__secondary-border-r___dN258`,
	"gap0": `TimeItem-module__gap-0____AL3d`,
	"gap2": `TimeItem-module__gap-2___wlMde`,
	"gap4": `TimeItem-module__gap-4___zbicR`,
	"gap5": `TimeItem-module__gap-5___j0I6C`,
	"gap6": `TimeItem-module__gap-6___XZYK2`,
	"gap8": `TimeItem-module__gap-8___QUncS`,
	"gap10": `TimeItem-module__gap-10___DV3xL`,
	"gap12": `TimeItem-module__gap-12___zr4ay`,
	"gap14": `TimeItem-module__gap-14___LcxVK`,
	"gap16": `TimeItem-module__gap-16___JgNSk`,
	"gap18": `TimeItem-module__gap-18___mguBq`,
	"gap20": `TimeItem-module__gap-20___eBQyI`,
	"gap24": `TimeItem-module__gap-24___zkfQA`,
	"gap26": `TimeItem-module__gap-26___B_HCj`,
	"gap30": `TimeItem-module__gap-30___i75u1`,
	"gap32": `TimeItem-module__gap-32___aHnZz`,
	"gap40": `TimeItem-module__gap-40___RMuls`,
	"gap50": `TimeItem-module__gap-50___XBJCq`,
	"flex1": `TimeItem-module__flex-1___io0Wl`,
	"flexNone": `TimeItem-module__flex-none___TeiCB`,
	"flexColumn": `TimeItem-module__flex-column___YXfaf`,
	"flexRow": `TimeItem-module__flex-row___ZP7cQ`,
	"verticallyCentered": `TimeItem-module__vertically-centered___G7LUR`,
	"horizontallyCentered": `TimeItem-module__horizontally-centered___d1ll8`,
	"horizontallyEnd": `TimeItem-module__horizontally-end___BopAo`,
	"verticallyStart": `TimeItem-module__vertically-start___AwVCn`,
	"spaceBetween": `TimeItem-module__space-between___odc2M`,
	"flexWrap": `TimeItem-module__flex-wrap___bRTI6`,
	"height100": `TimeItem-module__height-100___L86hp`,
	"width50": `TimeItem-module__width-50___rcF91`,
	"width100": `TimeItem-module__width-100___vIx4N`,
	"cursorPointer": `TimeItem-module__cursor-pointer___DN6C_`,
	"cursorNotAllowed": `TimeItem-module__cursor-not-allowed___DxXqS`,
	"absoluteCentered": `TimeItem-module__absolute-centered___WurpV`,
	"absolute": `TimeItem-module__absolute___VVogs`,
	"relative": `TimeItem-module__relative___hfa43`,
	"fixed": `TimeItem-module__fixed___rh4OW`,
	"visible": `TimeItem-module__visible___PyNhz`,
	"invisible": `TimeItem-module__invisible___qa91g`,
	"col90": `TimeItem-module__col-90___H6kvW`,
	"colAuto": `TimeItem-module__col-auto___iPc_D`,
	"medicalTabs": `TimeItem-module__medical-tabs___z90l3`,
	"medicalTableNew": `TimeItem-module__medical-table-new___QFxAK`,
	"noPagination": `TimeItem-module__no-pagination___j_wAe`,
	"medicalTableEmpty": `TimeItem-module__medical-table-empty___ryeOC`,
	"iconBtn": `TimeItem-module__icon-btn___HZR0y`,
	"searchIcon": `TimeItem-module__search-icon___dU6GW`,
	"disableSelect": `TimeItem-module__disable-select___fksen`,
	"breakWord": `TimeItem-module__break-word___u3wKm`,
	"popupClearBtn": `TimeItem-module__popup-clear-btn___wau8H`,
	"scrollMB20": `TimeItem-module__scroll-m-b-20___t6ReQ`,
	"date": `TimeItem-module__date___yx8r0`,
	"time": `TimeItem-module__time___JyWLk`
};
module.exports = ___CSS_LOADER_EXPORT___;
